import { useState, useEffect } from "react";
import { replaceUnderscore } from "../../../../../CommonFunction/common";
import { FormInputSectionComponent } from "../../../FormInputSectionComponent/FormInputSectionComponent";
import Input from "../../../Input/Input";
import { updateSingleField, updateValueForm } from "../../../FormInputSectionComponent/formUtils";

const AddStockItemSection = ({
  fielddata,
  inputfields,
  Type,
  Data,
  handleErrorsChange,
  ValidationName,
  TypeOfPortal,
  formkey,
  HanldeChangeonForm,
  formRef,
  TypeOfSelection,
  SelectedData,
  setSelectedData,
  FormData,
  setFirstLoad,
}) => {
  // const [SelectedData, setSelectedData] = useState("Goods");
  const [fields, setFields] = useState(inputfields);

  const handleSelectedDataChange = (e) => {
    setSelectedData(e.target.value);
  };

  useEffect(() => {
    const selectionKeys = Object.keys(TypeOfSelection); // Get keys from TypeOfSelection

    let newFields = [...fields];

    const existingIndex =
      fields.findIndex((field) => selectionKeys.includes(field.name)) ||
      fields.findIndex((field) => selectionKeys.includes(field.name));
    updateSingleField(formRef, fields[existingIndex]?.name, "");
    if (existingIndex !== -1) {
      newFields[existingIndex] = TypeOfSelection[SelectedData];
    } else {
      newFields.push(TypeOfSelection[SelectedData]);
    }

    setFields(newFields);
    setTimeout(() => {
      updateValueForm(formRef, FormData);
    }, 100);
  }, [SelectedData]);
  console.log(fields);
  return (
    <div className="FormSectionParent">
      <div className="VendorAccountradioContainer">
        {Object.entries(TypeOfSelection).map(([key, { name, label }]) => (
          <>
            <Input
              EMTQuery=""
              type="radio"
              id={key}
              name="SelectedData"
              value={key}
              checked={SelectedData === key}
              handleInputChange={handleSelectedDataChange}
              handleBlur={() => {}}
              InputConfig={{ type: "radio" }}
            />
            <label htmlFor={key}>{label === "HSN Code" ? "Goods" : label == "SAC Code" ? "Service" : label}</label>
          </>
        ))}
      </div>
      <>
        <div className="sectionHeadings">{replaceUnderscore(Type)}</div>
        <div className="FormSection">
          <FormInputSectionComponent
            fielddata={fielddata}
            inputfields={fields}
            Type={Type}
            onErrorsChange={handleErrorsChange}
            onhandleFormikChange={HanldeChangeonForm}
            ValidationName={ValidationName}
            TypeOfPortal={TypeOfPortal}
            formkey={formkey}
            formRef={formRef}
            setFirstLoad={setFirstLoad}
          />
        </div>
      </>
    </div>
  );
};

export default AddStockItemSection;
